"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const body_scroll_lock_1 = require("body-scroll-lock");
const react_1 = __importStar(require("react"));
const icons_1 = require("../../../../theme/icons");
const global_1 = require("../../../global");
const Dialog_styles_1 = require("./Dialog.styles");
const Dialog = ({ open, title, setOpen, closeText, closeFromOverlay, onCloseClick, opacity, children, }) => {
    const scrollRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        return () => {
            (0, body_scroll_lock_1.clearAllBodyScrollLocks)();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const scrollElement = scrollRef.current;
        if (open) {
            (0, body_scroll_lock_1.disableBodyScroll)(scrollElement);
        }
        else {
            (0, body_scroll_lock_1.enableBodyScroll)(scrollElement);
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        const handleKeyDown = (key) => {
            if (key === "Escape" || key === "Esc") {
                setOpen(false);
            }
        };
        window.addEventListener("keydown", handleKeyDown, true);
        return () => {
            window.removeEventListener("keydown", handleKeyDown, true);
        };
    }, [setOpen]);
    const onClickFn = (0, react_1.useMemo)(() => () => {
        setOpen(closeFromOverlay ? false : true);
    }, [closeFromOverlay, setOpen]);
    return (react_1.default.createElement(Dialog_styles_1.Wrapper, { ref: scrollRef, "$open": open, className: "rd-modal" },
        react_1.default.createElement(Dialog_styles_1.BackgroundArea, { onClick: onClickFn, "$opacity": opacity }),
        react_1.default.createElement(Dialog_styles_1.Modal, null,
            react_1.default.createElement(Dialog_styles_1.ModalHeaderContainer, null,
                react_1.default.createElement(Dialog_styles_1.Title, null, title),
                react_1.default.createElement(global_1.IconWrapper, { width: closeText ? 100 : 36, onClick: onCloseClick },
                    react_1.default.createElement(Dialog_styles_1.CloseWrapper, null,
                        closeText && react_1.default.createElement("span", null, closeText),
                        react_1.default.createElement(icons_1.Close, { size: "large" })))),
            react_1.default.createElement(Dialog_styles_1.ContentWrapper, null, children))));
};
exports.Dialog = Dialog;
//# sourceMappingURL=Dialog.js.map